import SocialConnectConnectorAbstract from './abstract.mjs';

/**
 * @class
 * @extends SocialConnectConnectorAbstract
 */
var SocialConnectConnectorFacebook = function() {

    let _this = this;

    $j.extend(this, new SocialConnectConnectorAbstract(this));

    this._clientInitialized = false;

    this.getType = function() {
        return 'facebook';
    };

    this._clientInit = function() {
        this._clientInitialized = true;

        FB.init({
            appId: this.getSettings()['clientId'],
            version: 'v7.0',
        });

        DeferredEvents.trigger(SocialConnectConnectorAbstract.EVENT_INIT_AFTER + '_' + this.getType());
    };

    /**
     * @returns {JQueryDeferred}
     */
    this._clientConnect = function() {
        return $j.Deferred(function() {
            let deferred = this;

            FB.login(function(response) {
                if (response.status === 'connected') {
                    let authResponse = response['authResponse'];

                    _this._clientConnectSuccessCallback({
                        'userId': authResponse['userID'],
                        'token': {
                            'access_token': authResponse['accessToken'],
                            'expires': authResponse['expiresIn'],
                        },
                    }).done(function(data) {
                        deferred.resolve(data);
                    });
                } else {
                    _this._clientConnectFailCallback(response);
                    deferred.reject(response);
                }
            }, {scope: _this.getSettings()['scope']});
        });
    };

    window.fbAsyncInit = function() {
        if (!_this._clientInitialized) {
            _this._clientInit();
        }
    };

    this.onInitSettingsAfter(function() {
        if (typeof FB !== 'undefined' && !_this._clientInitialized) {
            _this._clientInit();
        }
    });

    this.onInitAfter(function() {
        _this._initialized = true;
    });
};

export default SocialConnectConnectorFacebook;
